<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-file-marked-line me-1 text-primary"></i>Employee Qualification Lists
                </h5>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="300">Degree Name</th>
                  <th scope="col" width="200">Qualification Type</th>
                  <th scope="col" width="150">Specialization</th>
                  <th scope="col" width="200">Document File</th>
                  <th scope="col" width="200">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let qualification of qualifications | search : 'name' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{qualification.degreeName}}</td>
                  <td>{{qualification.qualificationType}}</td>
                  <td>{{qualification.specialization}}</td>
                  <td>
                    <ng-container *ngIf="qualification.documentUrl; else defaultAvatar">
                      <ng-container *ngIf="qualification.documentUrl.endsWith('.pdf'); else imagePreview" >
                        <i class="ri-file-pdf-line text-danger" style="font-size: 25px; cursor: pointer;" ngbTooltip="View pdf"
                          (click)="upsertpopup(qualification)"></i>
                      </ng-container>
                      <ng-template #imagePreview>
                        <img [src]="qualification.documentUrl" alt="Document Image" width="30" height="25" ngbTooltip="View"
                          (click)="upsertpopup(qualification)" style="cursor: pointer;" />
                      </ng-template>
                    </ng-container>
                    <ng-template #defaultAvatar>
                      <img src="assets/images/no_media.png" alt="Default Avatar" width="30" height="25" />
                    </ng-template>
                  </td>
                  <td> <span
                      class="badge rounded-pill bg-{{ qualification.verificationStatus === 'VERIFIED' ? 'success' : 'warning' }}">
                      {{ qualification.verificationStatus }}
                    </span></td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="6">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="qualifications && qualifications.length < 1; else noSearchResults">
                      <td colspan="6">No qualification were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="6"
                        *ngIf="searchKeyword && (qualifications | search : 'employeeName' : searchKeyword).length == 0">
                        No qualification were found.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>